module.exports = __webpack_public_path__ + "static/front-0d9fbbf196be9c887530a8116d9421ac.jpg";